import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgYoutube = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 12,
	height: 12,
	viewBox: "0 0 12 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "Social Icons",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Vector",
			d: "M11.8805 3.5999C11.8805 3.5999 11.7633 2.77256 11.4023 2.40928C10.9453 1.93115 10.4344 1.92881 10.2 1.90068C8.52188 1.77881 6.00234 1.77881 6.00234 1.77881H5.99766C5.99766 1.77881 3.47813 1.77881 1.8 1.90068C1.56563 1.92881 1.05469 1.93115 0.597656 2.40928C0.236719 2.77256 0.121875 3.5999 0.121875 3.5999C0.121875 3.5999 0 4.57256 0 5.54287V6.45225C0 7.42256 0.119531 8.39522 0.119531 8.39522C0.119531 8.39522 0.236719 9.22256 0.595312 9.58584C1.05234 10.064 1.65234 10.0476 1.91953 10.0991C2.88047 10.1905 6 10.2187 6 10.2187C6 10.2187 8.52188 10.214 10.2 10.0944C10.4344 10.0663 10.9453 10.064 11.4023 9.58584C11.7633 9.22256 11.8805 8.39522 11.8805 8.39522C11.8805 8.39522 12 7.4249 12 6.45225V5.54287C12 4.57256 11.8805 3.5999 11.8805 3.5999ZM4.76016 7.55615V4.1835L8.00156 5.87568L4.76016 7.55615Z",
			fill: "currentColor"
		})
	})
});
export default SvgYoutube;
